/** Keep in sync with Backend/constants/assetCategories.js */
export const ASSET_CATEGORIES = [
  "Laptop",
  "Desktop",
  "Monitor",
  "Phone",
  "Tablet",
  "Mouse",
  "Headphones",
  "Keyboard",
  "Dock",
  "Cable",
  "Accessory",
  "Server",
  "Networking",
  "Biometric",
  "CCTV",
  "Other",
];

export const ASSET_CATEGORY_GROUPS = [
  {
    label: "End-user devices",
    items: [
      "Laptop",
      "Desktop",
      "Monitor",
      "Phone",
      "Tablet",
      "Mouse",
      "Headphones",
      "Keyboard",
      "Dock",
      "Cable",
      "Accessory",
    ],
  },
  {
    label: "Infrastructure",
    items: ["Server", "Networking", "Biometric", "CCTV"],
  },
  {
    label: "Other",
    items: ["Other"],
  },
];
